import React, { useEffect } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";


import icon from "leaflet/dist/images/marker-icon.png";
import iconRetina from "leaflet/dist/images/marker-icon-2x.png";
import shadow from "leaflet/dist/images/marker-shadow.png";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: iconRetina,
  iconUrl: icon,
  shadowUrl: shadow,
});

const KMLViewer = ({ url }) => {
  useEffect(() => {
    if (!url) return;

    if (!window.omnivore) {
      const script = document.createElement("script");
      script.src =
        "https://unpkg.com/leaflet-omnivore@0.3.4/leaflet-omnivore.min.js";
      script.onload = () => loadMap();
      document.body.appendChild(script);
    } else {
      loadMap();
    }

    function loadMap() {
      const map = L.map("kml-map", {
        center: [20.5937, 78.9629],
        zoom: 5,
      });

      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: "&copy; OpenStreetMap contributors",
      }).addTo(map);

      window.omnivore.kml(url, null, L.geoJSON(null, {
        pointToLayer: function (feature, latlng) {
          return L.circleMarker(latlng, {
            radius: 8,
            fillColor: "#007bff",
            color: "#007bff",
            weight: 1,
            opacity: 1,
            fillOpacity: 0.8
          });
        }
      }))
      .on("ready", function () {
        map.fitBounds(this.getBounds());
      })
      .addTo(map);

      return () => map.remove();
    }

  }, [url]);

  return (
    <div
      id="kml-map"
      style={{
        width: "100%",
        height: "400px",
        borderRadius: "10px",
        overflow: "hidden",
      }}
    />
  );
};

export default KMLViewer;